(() => {
  if (window.FFHomeReviews) {
    window.FFHomeReviews.initialize();
    return;
  }
  const instances = new Map();
  function initialize() {
    const controls = document.querySelector('[data-ff-review-controls]');
    if (!controls) return;
    document.querySelectorAll('#main .jdgm-carousel-wrapper').forEach(root => {
      if (instances.has(root)) return;
      const section = root.closest('.shopify-section');
      if (!section) return;
      section.classList.add('ff-home-reviews');
      root.parentElement.classList.add('ff-review-app-host');
      const controller = new AbortController();
      const options = {signal:controller.signal};
      const dialog = document.createElement('dialog');
      dialog.className = 'ff-review-dialog';
      const header = document.createElement('header');
      const title = document.createElement('h3');
      title.id = `ff-review-dialog-title-${section.id}`;
      dialog.setAttribute('aria-labelledby',title.id);
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'ff-review-dialog__close';
      close.setAttribute('aria-label',controls.dataset.closeLabel);
      const closeIcon = document.createElement('span');
      closeIcon.setAttribute('aria-hidden','true');
      closeIcon.textContent = '×';
      close.append(closeIcon);
      header.append(title,close);
      const full = document.createElement('div');
      full.className = 'ff-review-dialog__body';
      dialog.append(header,full);
      section.append(dialog);
      let frame = 0;
      function enhance() {
        const heading = root.querySelector('.jdgm-carousel-title-and-link');
        if (heading && controls.dataset.eyebrow && !heading.querySelector('.ff-review-eyebrow')) {
          const eyebrow = document.createElement('p');
          eyebrow.className = 'ff-review-eyebrow';
          eyebrow.textContent = controls.dataset.eyebrow;
          heading.prepend(eyebrow);
        }
        const rating = root.querySelector('.jdgm-all-reviews-rating');
        const score = Number(rating?.dataset.score);
        if (rating && Number.isFinite(score) && score > 0 && score <= 5) {
          let value = root.querySelector('.ff-review-score');
          if (!value) {
            value = document.createElement('span');
            value.className = 'ff-review-score';
            value.setAttribute('aria-hidden','true');
            rating.before(value);
          }
          const text = `${score.toFixed(2)} / 5`;
          if (value.textContent !== text) value.textContent = text;
        }
        root.querySelectorAll('.jdgm-carousel-item').forEach(card => {
          const image = card.querySelector('.jdgm-carousel-item__product-image');
          if (image?.alt && !card.querySelector('.ff-review-product-label')) {
            const label = document.createElement('span');
            label.className = 'ff-review-product-label';
            label.textContent = image.alt;
            image.after(label);
          }
          const body = card.querySelector('.jdgm-carousel-item__review-body');
          const content = card.querySelector('.jdgm-carousel-item__review-content');
          if (!body || !content) return;
          let button = card.querySelector('.ff-review-read');
          const truncated = body.scrollHeight > body.clientHeight + 2;
          if (!button && truncated) {
            button = document.createElement('button');
            button.type = 'button';
            button.className = 'ff-review-read';
            button.setAttribute('aria-haspopup','dialog');
            button.textContent = controls.dataset.readLabel;
            content.append(button);
          }
          if (button) button.hidden = !truncated;
        });
        root.querySelectorAll('.jdgm-carousel__left-arrow,.jdgm-carousel__right-arrow').forEach(arrow => {
          arrow.setAttribute('role','button');
          arrow.tabIndex = 0;
          const icon = arrow.classList.contains('jdgm-carousel__left-arrow') ? '←' : '→';
          if (arrow.textContent !== icon) arrow.textContent = icon;
        });
      }
      function schedule() {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = 0; enhance(); });
      }
      root.addEventListener('click',event => {
        const button = event.target.closest('.ff-review-read');
        if (!button) return;
        const card = button.closest('.jdgm-carousel-item');
        title.textContent = card.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent.trim() || root.querySelector('h2').textContent;
        full.replaceChildren();
        const ratingText = card.querySelector('.jdgm-carousel-item__review-rating')?.getAttribute('aria-label');
        const reviewTitle = card.querySelector('.jdgm-carousel-item__review-title')?.textContent.trim();
        const reviewText = card.querySelector('.jdgm-carousel-item__review-body')?.innerText.trim();
        [ratingText,reviewTitle,reviewText].filter(Boolean).forEach(text => {
          const paragraph = document.createElement('p');
          paragraph.textContent = text;
          full.append(paragraph);
        });
        const image = card.querySelector('.jdgm-carousel-item__product-image');
        if (image?.alt) {
          const product = document.createElement('p');
          product.className = 'ff-review-dialog__product';
          product.textContent = image.alt;
          full.append(product);
        }
        dialog.showModal();
        full.scrollTop = 0;
      },options);
      root.addEventListener('keydown',event => {
        if (!event.target.matches('.jdgm-carousel__left-arrow,.jdgm-carousel__right-arrow')) return;
        if (!['Enter',' '].includes(event.key)) return;
        event.preventDefault();
        event.target.click();
      },options);
      close.addEventListener('click',()=>dialog.close(),options);
      dialog.addEventListener('click',event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      },options);
      const mutations = new MutationObserver(schedule);
      mutations.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['data-score']});
      const resize = new ResizeObserver(schedule);
      resize.observe(root);
      instances.set(root,()=>{
        controller.abort();
        mutations.disconnect();
        resize.disconnect();
        cancelAnimationFrame(frame);
        dialog.close();
        dialog.remove();
        section.classList.remove('ff-home-reviews');
      });
      schedule();
    });
  }
  window.FFHomeReviews = {initialize};
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',event=>{
    instances.forEach((cleanup,root)=>{
      if (!event.target.contains(root)) return;
      cleanup();
      instances.delete(root);
    });
  });
  initialize();
})();
